import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MycontentserviceService } from '../../_service/mycontentservice.service';
import { forkJoin } from 'rxjs';


declare let shaka: any | undefined;
declare var window: any | undefined;

@Component({
  selector: 'app-mycontent',
  templateUrl: './mycontent.component.html',
  styleUrls: ['./mycontent.component.css']
})
export class MycontentComponent implements OnInit {
 
  selectedTab:string='download';
  constructor(private mycontentservice: MycontentserviceService, private toaster: ToastrService) { }

  ngOnInit() {
    this.getDonwloadListCount();
    this.getUserCOntentCount();
 
   }
 
   getDonwloadListCount() {
     window.storage.list().then( (content) => {
       this.mycontentservice.downloadedCount = content.length;
     });
   }
 
   getUserCOntentCount() {
     var userId = localStorage.getItem("userId");
     forkJoin([this.mycontentservice.getUserWatchHistory(), this.mycontentservice.getWatchListOfUser(userId)]).subscribe( res => {
       console.log("response from forkJoin", res[0]);
       this.mycontentservice.watchHistoryCount = (this.removeDuplicates(res[0])).length;
       this.mycontentservice.watchListCount = res[1].length;
     })
   }
 
   removeDuplicates(data) {
     const tempObj = {};
     const finalResult = [];
     for(const ele of data) {
       if(!tempObj[ele.vidLibId]){
         finalResult.push(ele);
         tempObj[ele.vidLibId] = ele.vidLibId;
       }
     }
     return finalResult;
   }

  addInWatchList(isEnable, vidLibId) {   //changeEnabled
    console.log("isEnable:" + isEnable + ",vidLibId:" + vidLibId);
    console.log("addInWatchList called..")
    var userId = localStorage.getItem("userId");

    this.mycontentservice.addInWatchList(userId, vidLibId).subscribe(result => { 
      console.log(result);
      if (result == 0) {
        isEnable == false ? true : false;
        this.toaster.success("successfully added to the watchlist..");
      } else if (result == 1) {
        console.log("else block");
        this.toaster.success("unable to add please try again..");
      }
    })

  }



  onselectedTab(id) {
    this.selectedTab = id;
    this.mycontentservice.selectedTab = id;
  }


  removeFromWatchList(isEnable, vidLibId) {
    console.log("isEnable:" + isEnable + ",vidLibId:" + vidLibId);
    console.log("removeFromWatchList called")
    var userId = localStorage.getItem("userId");

    this.mycontentservice.removeFromWatchList(userId, vidLibId).subscribe(result => { //126

      if (result == 0) {
        isEnable == false ? true : false;
        this.toaster.success("successfully removed to the watchlist..");
      } else if (result == 1) {
        this.toaster.success("unable to remove please try again..");
      }
    })

  }


  

}
